import { render, staticRenderFns } from "./Inspection.vue?vue&type=template&id=4a5d4716&scoped=true&"
import script from "./Inspection.vue?vue&type=script&lang=ts&"
export * from "./Inspection.vue?vue&type=script&lang=ts&"
import style0 from "./Inspection.vue?vue&type=style&index=0&id=4a5d4716&prod&scoped=true&lang=css&"
import style1 from "./Inspection.vue?vue&type=style&index=1&id=4a5d4716&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d4716",
  null
  
)

export default component.exports